module.exports = __webpack_public_path__ + "img/banner3.091d97b.jpg";